import React, { useEffect, useState } from "react";
import { fetchData } from "../../Components/common/utils";
import { NavLink, useParams } from "react-router-dom";
import MainLoader from "../../Components/MainLoader";
function LatestProductDetail() {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    useEffect(() => {
        const fetchApiData = async () => {
            const url = "api/product/detail/" + id;
            const result = await fetchData(url);
            debugger
            if (result && result.data) {
                setData(result.data);
            }
            setLoading(false);
        };
        fetchApiData();
    }, [id]);

    return (
        <div className="container mt-4">
            {loading && <MainLoader />}
            <div className=" my-4">
                <h2 className="my-3">{data?.title}</h2>
                <p>{data?.short_description}</p>
                <div className="my-3" dangerouslySetInnerHTML={{ __html: data?.long_description }} />
                <div className="text-end">
                    <h3 className="fw-bold">Price : {data?.price}</h3>
                </div>
            </div>

        </div>
    )
}

export default LatestProductDetail;